import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import {
  CadsAmountDetailBitConfig,
  cadsAmountDetailSubtextColorCss,
} from './cads-amount-detail-bit.config';
import { CadsCreditValueStyle } from './cads-credit-value-style';

/**
 * Right-aligned **value** (USD) with optional **subtext** below. Supports credit / deposit sign and color rules via
 * {@link CadsCreditValueStyle} on {@link CadsAmountDetailBitConfig.isCredit}.
 */
@Component({
  selector: 'cads-amount-detail-bit',
  standalone: true,
  templateUrl: './cads-amount-detail-bit.component.html',
  styleUrl: './cads-amount-detail-bit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsAmountDetailBitComponent {
  readonly config = input.required<CadsAmountDetailBitConfig>();

  readonly effectiveConfig = computed(() => {
    const c = this.config();
    return {
      value: c.value,
      subtext: c.subtext,
      subtextTone: c.subtextTone ?? 'muted',
      size: c.size ?? 'medium',
      isCredit: c.isCredit,
    };
  });

  readonly formattedValue = computed(() => {
    const e = this.effectiveConfig();
    return new CadsCreditValueStyle(e.isCredit).formatted(e.value);
  });

  readonly valueColor = computed(() => {
    const e = this.effectiveConfig();
    return new CadsCreditValueStyle(e.isCredit).colorFor(e.value);
  });

  readonly subtextColor = computed(() => {
    const e = this.effectiveConfig();
    const t = e.subtext?.trim();
    if (!t) {
      return null;
    }
    return cadsAmountDetailSubtextColorCss(e.subtextTone);
  });

  readonly isSmall = computed(() => this.effectiveConfig().size === 'small');
  readonly isLarge = computed(() => this.effectiveConfig().size === 'large');
}
